import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Capa 1",
  viewBox: "0 0 72.29 72.69"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "Group 2" }, [
      _createElementVNode("path", {
        d: "M0 0h72.29v36.35H0z",
        "data-name": "Rectangle",
        style: {"fill":"#00aadb"}
      }),
      _createElementVNode("path", {
        d: "M0 36.35h72.29V72.7H0z",
        "data-name": "Rectangle 2",
        style: {"fill":"#3fa74d"}
      })
    ], -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "LV-logo"}) } }